// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Counter----counter-module---container---1nm4J"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Counter/counter.module.scss
// module id = 259
// module chunks = 35783957827783